import { z } from 'zod';
const translatedProductTextSchema = z.object({
    name: z.string().nullable(),
    description: z.string().nullable(),
});
/** German defaults remain the document line's authoritative name and description. */
export const productTextSnapshotSchema = z.object({
    version: z.literal(1),
    en: translatedProductTextSchema,
    tr: translatedProductTextSchema,
    fr: translatedProductTextSchema,
});
//# sourceMappingURL=product-text.js.map